import { Alert, AlertTitle } from "@material-ui/lab";
import React from "react";
import useStyles from "./style.js";

const SplAlert = ({ open, message, setClose }) => {
  const classes = useStyles();
  return (
    <>
      {}
      <Alert
        variant="filled"
        severity={"Warning"}
        classes={{ root: classes.splRoot, message: classes.messageContainer }}
        onClose={
          // setOpen(false);
          //   dispatchResetErrorMessage();
          setClose
        }
      >
        <div className={classes.alertDiv}>
          <AlertTitle>Warning</AlertTitle>
          {message}
        </div>
        {/* {hotelOrderStatus && (
        <div className={classes.actionButtonContainer}>
          <Button
            variant="contained"
            color="primary"
            className={
              error?.title === "Warning"
                ? classes.actionButton
                : classes.errorActionButton
            }
            onClick={onActionClick}
          >
            See Opening Hours
          </Button>
        </div>
      )} */}
      </Alert>
    </>
  );
};

export default SplAlert;
